export let autoDisconnectTimer: ReturnType<typeof setTimeout> | null = null;

// 120 minutes wall clock (aligned with audioServer hardMaxCallDurationMinutes)
const TWO_HOURS_MS = 120 * 60 * 1000;

function startedAtToMs(callStartedAt: Date | number | string | undefined | null): number | null {
    if (callStartedAt == null) return null;
    if (callStartedAt instanceof Date) return callStartedAt.getTime();
    if (typeof callStartedAt === 'number' && !Number.isNaN(callStartedAt)) return callStartedAt;
    const parsed = new Date(callStartedAt).getTime();
    return Number.isNaN(parsed) ? null : parsed;
}

/**
 * Clears the auto-disconnect timer if it's running.
 * Should be called when a call ends manually or is disconnected.
 */
export const clearAutoDisconnectTimer = (): void => {
    if (autoDisconnectTimer) {
        clearTimeout(autoDisconnectTimer);
        autoDisconnectTimer = null;
    }
};

/**
 * Starts the auto-disconnect timer (120 minutes wall clock from call start).
 *
 * @param callStartedAt Optional absolute start time (e.g. from server recovery). When omitted, uses "now".
 */
export const startAutoDisconnectTimer = (
    checkIsActive: () => boolean,
    stopSalesCall: () => void,
    callStartedAt?: Date | number | string | null
): void => {
    clearAutoDisconnectTimer();

    const startMs = startedAtToMs(callStartedAt) ?? Date.now();
    const elapsed = Date.now() - startMs;
    const delay = Math.max(0, TWO_HOURS_MS - elapsed);

    if (delay === 0) {
        if (checkIsActive()) {
            console.info('[SALES] Auto-disconnect: 120-minute limit already reached; stopping now');
            void stopSalesCall();
        }
        return;
    }

    autoDisconnectTimer = setTimeout(() => {
        if (checkIsActive()) {
            console.info('[SALES] Auto-disconnecting call after 120 minutes (wall clock)');
            void stopSalesCall();
        }
    }, delay);
};
